<script lang="ts">
    import { Button, Col } from "sveltestrap";
    import { AdvancedState, Danger, Information, Success, Warning } from "../../../utils/Constant/Constant";
    import Card from "../../Core/Card.svelte";
    import swal from 'sweetalert';
    const handleAlert =(id)=>{
        if(id === 1){
            swal("A wild Pikachu appeared! What do you want to do?", {
                buttons: {
                    cancel: "Run away!",
                    catch: {
                        text: "Throw Pokéball!",
                        value: "catch",
                    },
                    defeat: true,
                },
            })
            .then((value) => {
                switch (value) {
                    case "defeat":
                    swal("Pikachu fainted! You gained 500 XP!");
                    break;
                    case "catch":
                    swal("Gotcha!", "Pikachu was caught!", "success");
                    break;
                    default:
                    swal("Got away safely!");
                }
            });
        }
        else if(id === 2){
            swal("Are you sure you want to do this?", {
                buttons: ["Oh noo!", "Aww yes!"],
            });
        }
        else if(id === 3){
            swal("Write something here:", {
                content: "input",
            })
            .then((value) => {
                swal(`You typed: ${value}`);
            });
        }
        else if(id === 4){
            swal("Are you sure you want to do this?", {
                buttons: ["Oh noo!", "Aww yes!"],
            });
        }
    }
</script>
<Col sm="12">
    <Card headerTitle={AdvancedState} cardBodyprops="btn-showcase" cardHeaderprops="pb-0">
        <div slot="contentbody">
            <Button color="success" id=1 on:click={()=>handleAlert(1)} class="sweet-12" >{Success}</Button>
            <Button color="danger" id=1 on:click={()=>handleAlert(2)} class="sweet-11" >{Danger}</Button>
            <Button color="info" id=1 on:click={()=>handleAlert(3)} class="sweet-13" >{Information}</Button>
            <Button color="warning" id=1 on:click={()=>handleAlert(4)} class="sweet-10" >{Warning}</Button>
        </div>
    </Card>
</Col>  